var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaPay = function SvgVisaPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#visaPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1434CB",
    d: "m15.495 6.635-1.443 6.748h-1.746l1.444-6.748zm7.343 4.357.919-2.534.529 2.534zm1.947 2.391H26.4L24.99 6.635h-1.49a.795.795 0 0 0-.743.495l-2.619 6.253h1.833l.364-1.008h2.24zM20.23 11.18c.008-1.781-2.462-1.88-2.445-2.675.005-.242.236-.5.74-.565.25-.033.94-.058 1.721.302l.306-1.431a4.7 4.7 0 0 0-1.632-.3c-1.725 0-2.94.918-2.95 2.231-.01.972.867 1.514 1.528 1.837.68.33.909.542.906.838-.005.453-.543.653-1.045.66-.877.014-1.387-.236-1.793-.425l-.316 1.478c.408.187 1.16.35 1.942.358 1.833 0 3.032-.905 3.038-2.308m-7.229-4.545-2.828 6.748H8.328L6.937 7.998c-.085-.332-.158-.453-.415-.593-.42-.228-1.113-.441-1.722-.574l.041-.196h2.97c.379 0 .72.252.805.688l.735 3.905 1.816-4.593z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "visaPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgVisaPay;